import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ReportInfo } from '../../../Models/Models/Reports/ReportInfo';
import { IJsonDate } from '../../../System/IJsonDate';
import { CashTransactionTypes } from '../../../Models/Domains/Transactions/Cash/CashTransactionTypes';
import { SortDirection } from '../../../Core/SortingAndPaging/SortDirection';

declare var IS_RUNNING_IN_APP_POOL;

export class CashTransactionReportClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(hierarchyId: string, fromDate: IJsonDate, toDate: IJsonDate, fromInception: boolean, movementType: CashTransactionTypes, modelId: number, minRow: number, maxRow: number, sortDirection: SortDirection): Promise<ReportInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/Transaction/CashTransactionReport/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, fromDate: fromDate, toDate: toDate, fromInception: fromInception, movementType: movementType, modelId: modelId, minRow: minRow, maxRow: maxRow, sortDirection: sortDirection }

    return AjaxWrapper.post<ReportInfo, any>(url, data);
  }
}

